<template>
  <div>
    <IframeView :name="name" :url="`${baseUrl}/${name}`" :content-styles="contentStyles"
      :subContentStyles="subContentStyles" :removeSelectors="removeSelectors" :customScript="script" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import IframeView from '@/components/IframeView.vue';

const name = 'lenses';
const baseUrl = 'https://goyonorthamerica.com';
const contentStyles = '';
const subContentStyles = '';

const removeSelectors = [
  '.one-fourth.filtering-column',
  'a.btn.primary.hide-small',
];

const script = `
  $(".table tbody tr td").click((e) => {
    e.preventDefault();
    e.returnValue = false;
    return false;
  });
`;
</script>